export default "__VITE_ASSET__f8c9907a__"